import styled from 'styled-components';

const Cell = styled.div<any>`
  white-space: nowrap;
  ${({ width = '45%' }) => {
    return `width: ${width}`;
  }};
`;

export default Cell;
